import UserAvatar from "%/dynamic-component-editor/standard-pages/user-profile-page/UserAvatar.vue";
import Username from "%/dynamic-component-editor/standard-pages/user-profile-page/Username.vue";
import UserProfileTabs from "%/dynamic-component-editor/standard-pages/user-profile-page/UserProfileTabs.vue";
import UserBio from "%/dynamic-component-editor/standard-pages/user-profile-page/UserBio.vue";
import UserSplashImage from "%/dynamic-component-editor/standard-pages/user-profile-page/UserSplashImage.vue";
import FollowButton from "%/dynamic-component-editor/standard-pages/user-profile-page/FollowButton.vue";
import JoinedAtDate from "%/dynamic-component-editor/standard-pages/user-profile-page/JoinedAtDate.vue";
import MessageButton from "%/dynamic-component-editor/standard-pages/user-profile-page/MessageButton.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyUserProfile extends LegacyEntity {
  get elements() {
    return {
      UserAvatar,
      Username,
      UserProfileTabs,
      FollowButton,
      UserBio,
      UserSplashImage,
      JoinedAtDate,
      MessageButton,
    };
  }
}
